<template>
  <div>
    <div v-if="item">
      <ul class="nav nav-tabs  nav-tabs-line" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab"
             href="#kt_tabs_7_1"
             role="tab"><i class="la la-globe" /> Web / Social</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="tab"
             href="#kt_tabs_7_2"
             role="button" aria-haspopup="true"
             aria-expanded="false"><i class="la la-code-fork" /> Embed</a>
        </li>
        <li v-if="item.storage" class="nav-item">
          <a class="nav-link" data-toggle="tab"
             href="#kt_tabs_7_3"
             role="tab"><i class="la la-download" /> Download</a>
        </li>
        <li v-if="isFeed && user.is_super_admin" v-perms="['podcast_websites']" class="nav-item">
          <a class="nav-link" data-toggle="tab"
             href="#podcast_website"
             role="button" aria-haspopup="true"
             aria-expanded="false"><i class="la la-desktop" /> Podcast Website</a>
        </li>
      </ul>

      <div class="tab-content">
        <div id="kt_tabs_7_1" class="tab-pane active" role="tabpanel">
          <div class="mt-4">
            <h5>Player Direct Link</h5>
            <input id="player_url_input" type="text"
                   class="form-control kt-input mb-2"
                   :value="item.player_data.default_url" name="public_url"
                   readonly>
            <button class="btn btn-ss kt-btn kt-btn--icon" @click.stop.prevent="() => copyPlayerLinkToClipboard(item)">
              <span>
                <i class="la la-link" />
                <span>Copy Player Link</span>
              </span>
            </button>
            <button class="btn btn-ss kt-btn kt-btn--icon" @click.stop.prevent="() => copyEmbedToClipboard(item)">
              <span>
                <i class="la la-code" />
                <span>Copy Embed Code</span>
              </span>
            </button>
            <button v-if="item.published" class="btn btn-ss kt-btn kt-btn--icon" @click.stop.prevent="() => copyDirectFileLinkClipboard(item)">
              <span>
                <i class="la la-link" />
                <span>Copy Direct File Link</span>
              </span>
            </button>
            <button v-if="item.feed_xml_file_url" class="btn btn-ss" @click="() => copyRSSToClipboard(item)">
              <span>
                <i class="la la-rss" />
                <span>Copy RSS link</span>
              </span>
            </button>
            <a :href="item.player_data.default_url" target="_blank" class="btn btn-ss kt-btn kt-btn--icon">
              <span>
                <i class="la la-eye" />
                <span>Preview embed</span>
              </span>
            </a>
          </div>

          <div class="mt-5">
            <h5>Share on Social</h5>
            <button class="btn btn-ss" @click="shareOnFacebook(item)">
              <span>
                <i class="socicon-facebook" />
                <span>Share on Facebook</span>
              </span>
            </button>
            <button class="btn btn-ss" @click="shareOnTwitter(item)">
              <span>
                <i class="socicon-twitter" />
                <span>Share on Twitter</span>
              </span>
            </button>
            <button class="btn btn-ss" @click="shareOnWhatsapp(item)">
              <span>
                <i class="socicon-whatsapp" />
                <span>Share on WhatsApp</span>
              </span>
            </button>
          </div>
        </div>
        <div id="kt_tabs_7_2" class="tab-pane" role="tabpanel">
          <player-iframe-preview :item="item" :show-tools="true" :is-feed="isFeed" />
        </div>
        <div v-if="item.storage" id="kt_tabs_7_3"
             class="tab-pane"
             role="tabpanel">
          <h5>{{ item.storage.name }} <span>- {{ formatBytes(item.storage.file_size) }}</span></h5>
          <a :href="`/storage/massDownload?selected=${item.storage.uuid}`" target="_blank" class="btn kt-btn btn-ss">Download</a>
        </div>
        <div v-if="isFeed"
             id="podcast_website"
             class="tab-pane"
             role="tabpanel">
          <podcast-website :feed="item" />
        </div>
      </div>
    </div>
    <div v-else>
      Items must be published before they can be shared.
    </div>
  </div>
</template>

<script>
import PlayerIframePreview from "VueComponents/PlayerIframePreview";
import {
  formatBytes,
} from "Helpers/formatters";
import SocialShareMixin from 'VueMixins/SocialShareMixin';
import PodcastWebsite from "VuePartials/PodcastWebsite";

export default {
  components: {
    PlayerIframePreview,
    PodcastWebsite,
  },
  mixins: [SocialShareMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    isFeed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    user: window.user,
    player_data: window.player_data,
  }),
  mounted() {
    this.initSocial();
  },
  methods: {
    formatBytes(bytes) {
      return formatBytes(bytes, 2);
    },
    getPlayerUrl() {
      if (this.item && this.item.player_data) {
        // @todo this needs to be dynamic
        return this.item.player_data.basic_url;
      }

      return '';
    },
  },
};
</script>
